export default __webpack_public_path__ + "static/media/circle_exclamation.83e59d2f.svg";